import { render, staticRenderFns } from "./ProductSummaryTable.vue?vue&type=template&id=0bfe039c&"
import script from "./ProductSummaryTable.vue?vue&type=script&lang=js&"
export * from "./ProductSummaryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports